import React from "react";
import { Grid, Typography, Box, useMediaQuery } from "@mui/material";
import { useLocation, useNavigate, Routes, Route } from "react-router-dom";
import EntryList from "../entries/EntryList";
import EntryDetailLayout from "./EntryDetailLayout";
import Iconify from "src/components/iconify";

export default function EntryContentArea({
  years,
  sortedItems,
  selectedItem,
  setSelectedItem,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const handleSelectItem = (item) => {
    navigate(`/dashboard/entry/${item._id}`); // Navigiert zur Detailansicht
    setSelectedItem(item);
  };

  const isEntryDetailView = location.pathname.includes("/dashboard/entry/");

  return (
    <Grid
      container
      spacing={0}
      style={{
        width: "100%",
        height: "100%",
        flexDirection: isMobile && isEntryDetailView ? "column" : "row",
        overflow: "hidden",
      }}
    >
      {/* Linke Liste (nur sichtbar, wenn nicht in der Detailansicht oder nicht auf einem mobilen Gerät) */}
      {!isMobile || !isEntryDetailView ? (
        <Grid
          item
          xs={12}
          md={4}
          sx={{
            height: "70vh",
            overflowY: "scroll", // Scrollbar wird immer angezeigt
            transition: "overflow-y 0.2s ease-in-out",
            "&:hover": { overflowY: "auto" }, // Automatischer Scroll auf Hover
          }}
        >
          <EntryList
            years={years}
            sortedItems={sortedItems}
            handleSelectItem={handleSelectItem}
            selectedItem={selectedItem}
          />
        </Grid>
      ) : null}

      {/* Rechte Detailansicht */}
      <Grid
        item
        xs={12}
        md={8}
        style={{
          height: "100vh",
          overflowY: "auto",
        }}
      >
        {isMobile && isEntryDetailView ? (
          <Routes>
            <Route path=":id" element={<EntryDetailLayout />} />
          </Routes>
        ) : (
          <Routes>
            <Route
              index
              element={
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  height="100%"
                >
                  <Typography variant="h6" sx={{ textAlign: "center" }}>
                    <Iconify
                      icon="line-md:list-3"
                      sx={{
                        color: "text.disabled",
                        width: 40,
                        height: 40,
                        marginRight: 1,
                      }}
                    />
                    Wählen Sie ein Element aus der Liste aus.
                  </Typography>
                </Box>
              }
            />
            <Route path=":id" element={<EntryDetailLayout />} />
          </Routes>
        )}
      </Grid>
    </Grid>
  );
}
